export const customStyles = {
    tableWrapper: {
        style: {
            "padding-left": '0px',
            "padding-right": '0px',
            // "overflow-x": "auto"
        //
        }
    },
    rows: {
        style: {
            // background: '#29b7b9',
            minHeight: '30px', // override the row height
            // wordWrap: 'break-word',

        },
    },
    columns: {
        style: {
            // minWidth: '60px!important', // override the row height
            // whiteSpace:'unset',
            // wordWrap: 'break-word',
            // textAlign: 'right',
            // whiteSpace:'unset',
        },
    },
    header: {
        style: {
            "border-radius": "10px",
            // whiteSpace:'unset',

        }
    },
    headCells: {
        style: {
            paddingLeft: '2px', // override the cell padding for data cells
            paddingRight: '2px',
            color: '#fff',
            background: '#29b7b9',
            // textAlign:'center',
            minWidth: '30px!important', // override the row height
            // whiteSpace:'unset !important',
            // wordWrap: 'break-word',

        },
    },

    cells: {
        style: {
            paddingLeft: '2px', // override the cell padding for data cells
            paddingRight: '2px',
            background: '#fff',
            minWidth: '30px!important', // override the row height
            textAlign: 'center',
            // whiteSpace:'unset !important',
            // wordWrap: 'break-word',

        },
    },
    // rdt_TableRow:{
    //     backgroundColor: '#29b7b9',
    // }
};
